// extracted by mini-css-extract-plugin
export default {"root":"edit_button-module___root___a5a161b3","inner":"edit_button-module___inner___e3696592","icon":"edit_button-module___icon___e1e03c07"};